export default /*css*/ `
  :host {
    --background-dim-color: var(--cart-drawer-bg-dim-color, rgba(0, 0, 0, 0.4));
    --top-margin: var(--cart-drawer-wrapper-top-margin, 3.5rem);
    --cart-modal-border-radius: var(--cart-drawer-wrapper-bd-radius, 0);
    --cart-modal-width: calc(100% - 32px);
    --cart-overlay-display-mobile: none;
  }
  .cart-wrapper__overlay ::slotted(cart-items-list) {
    height: 100%;
    min-width:380px;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: var(--cart-drawer-items-list-bg, #ffffff);
  }
  .cart-wrapper {
    display: flex;
  }
  .cart-wrapper__modal {
    position: fixed;
    top: 50%;
    left: 50%;
    background-color: white;
    border-radius: var(--cart-modal-border-radius);
    overflow: hidden;
    z-index: 9999;
    transform: translate(-50%, -50%);
    border: 1px solid rgba(0, 0, 0, 0.4);
    opacity: 0;
    animation: fadeInAnimation 0.2s ease forwards;
    min-width: 358px;
    width: var(--cart-modal-width);
    max-height: 80vh;
    display: flex;
    flex-direction: column;
  }
  .cart-wrapper__modal ::slotted(cart-items-list) {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .cart-wrapper__modal.hidden {
    display: none;
    animation: fadeOutAnimation 0.2s ease forwards;
  }
  slot[name="background"] {
    animation: fadeInAnimation 0.2s ease forwards;
  }
  slot[name="background"].hidden {
    display: none;
    animation: fadeOutAnimation 0.2s ease forwards;
  }
  .cart-wrapper__overlay {
    display: var(--cart-overlay-display-mobile);
    flex-direction: column;
    position: fixed;
    top: var(--top-margin);
    right: 0px;
    max-width: 380px;
    height: calc(100vh - var(--top-margin));
    background-color: white;
    overflow: hidden;
    z-index: 9999;
    transition: 0.1s;
    animation: slideInFromRight 0.2s ease-in-out forwards;
  }
  .cart-wrapper__overlay.hidden {
    animation: slideOutToRight 0.2s ease-in-out forwards;
  }
  ::slotted(.cart-wrapper__bg) {
    left: 0;
    width: 100vw;
    z-index: 9998;
    min-width: 100vw;
    position: fixed;
    top: var(--top-margin);
    height: calc(100vh - var(--top-margin));
    background-color: var(--background-dim-color);
  }
  ::slotted(.cart-wrapper__bg.modal) {
    top: 0;
    height: 100vh;
  }
  ::slotted(.cart-wrapper__bg.overlay) {
    top: var(--top-margin);
    height: calc(100vh - var(--top-margin));
  }
  .cart-wrapper__button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: var(--cart-button-height);
    width: var(--cart-button-width);
    color: var(--cart-button-fg);
    background-color: var(--cart-button-bg);
    border: 1px solid var(--cart-button-border-color);
    border-radius: var(--cart-button-border-radius);
    font-size: var(--cart-button-font-size);
  }
  @keyframes slideInFromRight {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @keyframes slideOutToRight {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    100% {
      transform: translateX(100%);
      opacity: 0;
    }
  }
  @keyframes fadeInAnimation {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
  }
  @keyframes fadeOutAnimation {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
  }
  @media(min-width: 768px) {
    :host {
      --cart-modal-width: auto;
    }
    .cart-wrapper__modal {
      max-width: 364px;
    }
  }
  @media(min-width: 1024px) {
    :host {
      --top-margin: var(--cart-drawer-wrapper-top-margin, 4.55rem);
      --cart-overlay-display-mobile: flex;
    }
  }
`;
